













import { Component, Vue, Watch, Inject } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')

@Component
export default class Breadcrumb extends Vue {
  public get levelList(): RouteRecord[] {
    const initItems = [{ path: '/', meta: { title: '首页' }, name: '首页', redirect: 'noredirect' } as RouteRecord]
    if (!this.menus || this.menus.length === 0) {
      return initItems
    }
    const path: string = this.$route.matched[0].path.toLowerCase()
    if (path == '' || path == '/' || path == '/dashboard') {
      return initItems
    }
    const list: RouteRecord[] = []
    list.push({ path: '/', meta: { title: '首页' }, name: '首页', redirect: '/dashboard' } as RouteRecord)
    if (path === '/unitgis') {
      list.push({
        path: '/UnitGis', meta: { title: '文保单位GIS' },
        name: '文保单位GIS', redirect: '/UnitGis'
      } as RouteRecord)
    }
    if (path === '/myprofile') {
      list.push({
        path: '/MyProfile', meta: { title: '个人信息' },
        name: '个人信息', redirect: '/MyProfile'
      } as RouteRecord)
    }
    this.menus.forEach(menu => {
      const model: RouteRecord = {
        path: menu.Path, meta: { title: menu.Name }, name: menu.Name, redirect: menu.Path
      } as RouteRecord

      if (path === menu.Path.toLowerCase()) {
        list.push(model)
      } else if (menu.Children) {
        menu.Children.forEach((child: any) => {
          if (path === child.Path.toLowerCase()) {
            model.path = ''
            model.redirect = 'noredirect'
            list.push(model)
            const childModel: RouteRecord = {
              path: child.Path, meta: { title: child.Name }, name: child.Name, redirect: child.Path
            } as RouteRecord
            list.push(childModel)
          }
        })
      }
    })
    const excludeRoute: string[] = ['/', '/dashboard', '/unitgis', '/myprofile']
    if (excludeRoute.findIndex(v => v == path) < 0) {
      const fullPath: string = this.$route.path.toLowerCase()
      if (path != fullPath) {
        const sp: string[] = fullPath.split('/')
        const act: string = sp[2]
        const actNames: { [key: string]: string } = {
          'new': '新增',
          'discover': '发现设备',
          'edit': '修改',
          'copy': '复制',
          'newmakeup': '新增-线下巡查',
          'editmakeup': '修改-线下巡查',
          'view': '查看',
          'approve': '审核',
          'transfer': '转岗'
        }
        const actName = actNames[act]
        if (actName) {
          const actModel: RouteRecord = {
            path: '#', meta: { title: actName }, name: actName, redirect: 'noredirect'
          } as RouteRecord
          list.push(actModel)
        }
      }
    }
    return list
  }

  @UserModule.Getter
  public menus!: any[]

  public created() {
  }

  @Watch('$route')
  public onRouteChange(route: any) {
  }
}
